/**
 * OrbDocTutorialsIntermediateUiPatternsSLDocScreenView
 *
 * Functional component — logic + state-based JSX rendering.
 *
 * @generated from schema
 * @trait OrbDocTutorialsIntermediateUiPatternsSLDocScreen
 */

import { useOrbDocTutorialsIntermediateUiPatternsSLDocScreenLogic } from '@/hooks/traits/useOrbDocTutorialsIntermediateUiPatternsSLDocScreenLogic';
import type { OrbDocTutorialsIntermediateUiPatternsSLDocScreenConfig } from '@/hooks/traits/useOrbDocTutorialsIntermediateUiPatternsSLDocScreenLogic';
import type { EntityRow, EntityWith, EventPayload, EventPayloadValue, FieldValue } from '@almadar/core';
function getNestedValue(obj: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined, path: string): FieldValue | undefined {
  if (obj === null || obj === undefined || !path) return undefined;
  if (typeof obj !== 'object') return undefined;
  if (!path.includes('.') && !Array.isArray(obj)) {
    return (obj as Record<string, FieldValue | undefined>)[path];
  }
  let value: EventPayload | EventPayloadValue | FieldValue | Record<string, FieldValue | undefined> | null | undefined = obj;
  for (const part of path.split('.')) {
    if (value === null || value === undefined || typeof value !== 'object') return undefined;
    if (Array.isArray(value)) {
      if (!/^\d+$/.test(part)) return undefined;
      value = (value as readonly (EventPayloadValue | FieldValue | null | undefined)[])[Number(part)];
      continue;
    }
    value = (value as Record<string, FieldValue | undefined>)[part];
  }
  return value as FieldValue | undefined;
}
import type { OrbDocTutorialsIntermediateUiPatternsSLDocView as OrbDocTutorialsIntermediateUiPatternsSLDocViewEntity } from '@app/shared';
import { OrbDocTutorialsIntermediateUiPatternsSLDocBodyView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsSLDocBodyView';
import { OrbDocTutorialsIntermediateUiPatternsSLDocFooterView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsSLDocFooterView';
import { OrbDocTutorialsIntermediateUiPatternsSLDocHeaderView } from '@/components/traits/OrbDocTutorialsIntermediateUiPatternsSLDocHeaderView';
import { Stack } from '@almadar/ui/components';
import { UISlotComponent } from '@almadar/ui/components';
import { TraitScopeProvider } from '@almadar/ui/providers';

interface OrbDocTutorialsIntermediateUiPatternsSLDocScreenViewProps {
  config?: Partial<OrbDocTutorialsIntermediateUiPatternsSLDocScreenConfig>;
}

export function OrbDocTutorialsIntermediateUiPatternsSLDocScreenView({ config: propsConfig }: OrbDocTutorialsIntermediateUiPatternsSLDocScreenViewProps) {
  const { state, data, lastPayload, lastEvent, slotWriter, loading, pendingEvent, pendingFrom, error, fields, dispatch, actions, config } = useOrbDocTutorialsIntermediateUiPatternsSLDocScreenLogic(propsConfig);

  // Entity collection from server response data
  const entity: EntityRow[] = data['OrbDocTutorialsIntermediateUiPatternsSLDocView'] ?? [];
  // Payload from last event (for @payload bindings in render-ui)
  const payload = lastPayload;

  return (
    <TraitScopeProvider orbital="OrbDocTutorialsIntermediateUiPatternsSL" trait="OrbDocTutorialsIntermediateUiPatternsSLDocScreen">
      <UISlotComponent slot="main" pattern={slotWriter['main'] === 'INIT' ? "stack" : "clear"} sourceTrait="OrbDocTutorialsIntermediateUiPatternsSLDocScreen">{slotWriter['main'] === 'INIT' ? (<Stack direction="vertical" gap="none"><OrbDocTutorialsIntermediateUiPatternsSLDocHeaderView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateUiPatternsSLDocBodyView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /><OrbDocTutorialsIntermediateUiPatternsSLDocFooterView config={{ entityId: propsConfig?.entityId, routeParams: propsConfig?.routeParams, initPayload: propsConfig?.initPayload }} /></Stack>) : null}</UISlotComponent>
    </TraitScopeProvider>
  );
}

export default OrbDocTutorialsIntermediateUiPatternsSLDocScreenView;
